<template>
  <!-- 重要通知 -->
  <div
    class="masks"
    v-if="displayMask"
  >
    <div class="middle">
      <img
        class="close"
        src="../../static/image/close.png"
        alt=""
        @click="closeClick()"
      >
      <div class="title">
        <img
          class="titleImg"
          src="../../static/image/mask1.png"
          alt=""
          srcset=""
        >
        <div class="smoll">
          <p class="name">{{detail.tips_name_cn}}</p>
          <p class="date">{{detail.send_time}}</p>
        </div>

      </div>
      <div
        class="maskContent"
        v-html="detail.tips_content_cn"
      >
      </div>
    </div>
  </div>
</template>
<script>
// tipsGteDetails
import { tipsGteDetails } from "@/api/home";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "ImportantNotice",
  data() {
    return {
      displayMask: false,
      detail: {}
    };
  },
  computed: {
    ...mapState("user", ["mask"])
  },
  methods: {
    ...mapMutations("user", ["SET_MASK"]),
    //   关闭弹窗
    closeClick() {
      this.displayMask = false;
    }
  },
  mounted() {
    var mask = sessionStorage["mask"];
    // sessionStorage
    if (!mask) {
      tipsGteDetails({}).then(res => {
        this.detail = res.data;
        // this.SET_MASK(1);
        sessionStorage["mask"] = 1;
        if (res.data.status == 1) {
          this.displayMask = true;
        } else {
          this.displayMask = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/custom/common.scss";
.masks {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}
.middle {
  position: absolute;
  width: px2Rem(900px);
  height: px2Rem(650px);
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .close {
    position: absolute;
    width: px2Rem(40px);
    height: px2Rem(40px);
    right: px2Rem(-60px);
    top: px2Rem(-20px);
    cursor: pointer;
  }
  .titleImg {
    width: 100%;
    height: px2Rem(250px);
    // z-index: 0;
  }
  .title {
    position: relative;
    .smoll {
      position: absolute;
      top: px2Rem(60px);
      left: px2Rem(60px);
    }
    .name {
      font-size: px2Rem(76px);
      font-family: "SourceHanSansCN";
      // font-family: "noto sans";
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      text-shadow: 5px 2px 6px #000;
    }
    .date {
      width: px2Rem(312px);
      height: px2Rem(50px);
      margin-top: px2Rem(10px);
      background: rgba(255, 255, 255, 1);
      border-radius: px2Rem(25px);
      text-align: center;
      line-height: px2Rem(50px);
      font-size: px2Rem(30px);
      font-family: "SourceHanSansCN";
      // font-family: "noto sans";
      // font-weight: bold;
      color: rgba(231, 72, 28, 1);
    }
  }
  .maskContent {
    height: px2Rem(320px);
    padding: px2Rem(50px) px2Rem(25px) px2Rem(0px);
    overflow-y: auto;
    font-size: px2Rem(30px);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/ImportantNotice.vue